// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.store-addons-for-woocommerce-media-uploader-unit .media-uploader {
  width: 100%;
  max-width: 300px;
}
.store-addons-for-woocommerce-media-uploader-unit .media-uploader .file-name {
  cursor: pointer;
}
.store-addons-for-woocommerce-media-uploader-unit .media-uploader .file-name .remove-image-icon {
  font-size: 24px;
  top: -24px;
  right: -24px;
  cursor: pointer;
}
.store-addons-for-woocommerce-media-uploader-unit .media-uploader .file-name .uploaded-image-icon {
  font-size: 50px;
}
.store-addons-for-woocommerce-media-uploader-unit .media-uploader .file-name.file-name-without-image {
  border-style: dashed !important;
}/*# sourceMappingURL=MediaUploader.css.map */`, "",{"version":3,"sources":["webpack://./src/components/MediaUploader/MediaUploader.scss","webpack://./src/components/MediaUploader/MediaUploader.css"],"names":[],"mappings":"AACI;EACI,WAAA;EACA,gBAAA;ACAR;ADCQ;EACI,eAAA;ACCZ;ADAY;EACI,eAAA;EACA,UAAA;EACA,YAAA;EACA,eAAA;ACEhB;ADAY;EACI,eAAA;ACEhB;ADAY;EACI,+BAAA;ACEhB,CAAA,4CAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
